<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="active"
    class="items-no-padding department-edit">
    <div class="h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div class="dialog-title">
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">

        <div class="px-6">
          <el-form
            :model="form"
            :rules="rules"
            hide-required-asterisk
            label-position="top"
            ref ="form"
          >
            <el-form-item
              label="产品名称"
              prop="name"
            >
              <el-input
                v-model="form.name"
                placeholder="请输入"
              ></el-input>

            </el-form-item>
            <el-form-item
              label="产品编码"
              prop="code"
            >
              <el-input
                v-model="form.code"
                placeholder="请输入"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="状态"
              prop="status"
              class="blod-form-item"
            >
              <vs-radio
                v-model="form.status"
                vs-name="radios1"
                class="mar-right10"
                :vs-value="0"
              >启用</vs-radio>
              <vs-radio
                v-model="form.status"
                vs-name="radios1"
                class=""
                :vs-value="1"
              >禁用</vs-radio>
            </el-form-item>
            <el-form-item>
              <vs-button @click="submit" class="mar-right10" type="filled" color="primary">确认</vs-button>
              <vs-button @click="cancel" type="border"  color="primary">取消</vs-button>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>
  import { updateProduct, createProduct } from '@/api/product'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    export default {
        name: "editOrAdd",
      props: {
        active: {
          type: Boolean,
          default: false
        },
        isEdit:{
          type: Boolean,
          default: false
        },
        editData:{
          type: Object,
          default(){
            return {
              name: '',
              code: '',
              //不能有空格
              status: 0
            }
          }
        }
      },
      components: {
        VuePerfectScrollbar,
      },
      data() {
        return {
          settings: {
            maxScrollbarLength : 60,
            wheelSpeed         : .60,
          },
          form:{
            name: '',
            code: '',
            status: 0,
          },
          rules:{
            // 名字有长度限制以及不能输入空格
            name:[
              { required: true, message: '请输入', trigger: 'blur' }
            ],
            code:[
              { required: true, message: '请输入', trigger: 'blur' }
            ],
          }
        }
      },
      watch: {
        editData(newValue, oldValue) {
          if(newValue.id){
            this.form.id = newValue.id;
            this.form.name = newValue.productName;
            this.form.code = newValue.productCode;
            this.form.status = newValue.status;
          }else {
            this.form = {
              name: '',
              code: '',
              status: 0,
            }
          }
        },
        active(newValue){
          if(newValue){
            this.$refs.form.clearValidate();
          }
        }
      },
      computed: {
        title() {
          return this.isEdit ? '编辑产品': '添加产品';
        }
      },
      methods: {

        close(){
          this.reset();
          this.$emit('close');
        },
        reset(){
          this.form = {
            name: '',
            code: '',
            status: 0,
          };
        },
        closeHandle() {

          this.$refs.form.resetFields();
          this.close();
        },
        cancel(){
          this.$refs.form.resetFields();
          this.close();
        },
        submit(){
            this.$refs.form.validate((valid) => {
              if(valid){
                // ajax
                let params = {
                  productName: this.form.name,
                  productCode: this.form.code,
                  status: this.form.status,
                };
                if(this.isEdit){
                  params.id = this.form.id;
                  updateProduct(params).then((res) => {
                    this.close();
                    this.$emit('done-success');
                    this.$vs.notify({
                      position: 'top-right',
                      text: '操作成功'
                    })
                  });
                }else {
                  createProduct(params).then((res) => {
                    this.close();
                    this.$emit('done-success');
                    this.$vs.notify({
                      position: 'top-right',
                      text: '操作成功'
                    })
                  });
                }

              }else {
                console.log('no-pass');
              }
            })
        }
      },
    }
</script>

<style lang="scss">
  .department-edit {
    .vs-sidebar {
      position: fixed;
      z-index: 999;
      width: 360px;
      max-width: 90vw;
      // @apply shadow-lg;
      box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    }
    .scroll-area--customizer {
      height: calc(100% - 5rem);
    }
    .el-select {
      width: 100%;
    }
  }


</style>
